export const painPoints = [
  'Jabones que no huelen a nada después de dos días.',
  'Mezclas que se cortan o quedan demasiado blandas.',
  'Tutoriales de internet que usan ingredientes imposibles de conseguir en Argentina.',
  'No tener idea de cómo ponerle precio a tu trabajo y terminar perdiendo plata.',
]

export type MasteryItem = {
  title: string
  description: string
}

export const masteryItems: MasteryItem[] = [
  {
    title: 'Alquimia Natural',
    description:
      'Dominá el uso de aceites, mantecas y colorantes naturales (arcillas, semillas, especias).',
  },
  {
    title: 'Recetario Terapéutico',
    description:
      'Creá jabones para acné, piel seca, exfoliantes, relajantes y más.',
  },
  {
    title: 'Diseño de Autor',
    description:
      'Técnicas de capas, incrustaciones de flores secas y marmoleado profesional.',
  },
  {
    title: 'Tu Tienda en Casa',
    description:
      'Cómo calcular costos reales y cómo presentar tus jabones para que se vendan como un producto de boutique.',
  },
]

export type StackItem = {
  label: string
  name: string
  value: string
  isMain?: boolean
}

export const stackItems: StackItem[] = [
  {
    label: '📘',
    name: 'El Manual Maestro de Jabonería Artesanal',
    value: '$18.000',
    isMain: true,
  },
  {
    label: '🎁',
    name: 'BONO 1: Guía de Proveedores Mayoristas (Argentina)',
    value: '$5.000',
  },
  {
    label: '🎁',
    name: 'BONO 2: Recetario "Farmacia en el Baño" (20 Fórmulas)',
    value: '$7.000',
  },
  {
    label: '🎁',
    name: 'BONO 3: Masterclass de Packaging Ecológico',
    value: '$4.000',
  },
  {
    label: '🎁',
    name: 'BONO 4: Calculadora de Costos y Precios',
    value: '$3.500',
  },
  {
    label: '🎁',
    name: 'BONO 5: Guía de Ventas por Instagram y WhatsApp',
    value: '$6.000',
  },
]

export type FaqItem = {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question: '¿Necesito herramientas especiales?',
    answer:
      'No. Podés empezar con utensilios que ya tenés en tu cocina. En la guía te explicamos cómo desinfectar y separar lo que necesitás.',
  },
  {
    question: '¿Es peligroso trabajar con estos materiales?',
    answer:
      'En este método nos enfocamos en técnicas seguras y amigables (Glicerina y bases naturales), ideales para aprender en casa sin riesgos.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Al confirmar tu pago, recibís un email automático con todos los archivos en PDF para descargar en tu celular, tablet o computadora.',
  },
]

export const CTA_TEXT = '🧼 ¡SÍ, QUIERO SER UNA MAESTRA JABONERA POR $19.990!'

export const CHECKOUT_URL = 'https://maestro-jabonero.impultienda.ar/checkout'
